import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Header from './Header'
import Footer from './Footer'
import $ from 'jquery'


ReactDOM.render(
  <React.StrictMode>
  <Header/>
    <App />
  <Footer/>
  </React.StrictMode>,
  document.getElementById('root')
);
$("#bill,#people,#tip").on("input", function() {
  if (/^0/.test(this.value)) {
    this.value = this.value.replace(/^0/, "")
  }
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
